<template>
  <div id="mapdiv"></div>
</template>
<script>
    import * as axios from 'axios';
    export default {
        components: {
        },
        data () {
            return {
                currentPage: 1,
            }
        },
        created(){
          map = new OpenLayers.Map("mapdiv");
          map.addLayer(new OpenLayers.Layer.OSM());

          var lonLat = new OpenLayers.LonLat( -0.1279688 ,51.5077286 )
                .transform(
                  new OpenLayers.Projection("EPSG:4326"), // transform from WGS 1984
                  map.getProjectionObject() // to Spherical Mercator Projection
                );
                
          var zoom=16;

          var markers = new OpenLayers.Layer.Markers( "Markers" );
          map.addLayer(markers);
          
          markers.addMarker(new OpenLayers.Marker(lonLat));
          
          map.setCenter (lonLat, zoom);
        },
        methods:{
            changePage() {
            },
        }
    }
</script>
<style scoped>
::v-deep .modal-content {
    margin: -3.25rem auto;
}

.btn {
    padding : 2px 6px;
}
</style>
